module.exports = __webpack_public_path__ + "img/lowerabs-ectomorph-female.d1caa86c.svg";